// import Vue from 'vue'
// import VueRouter from 'vue-router'
import { createRouter, createWebHistory } from 'vue-router'
// import 'es6-promise'
// import VModal from 'vue-js-modal'
// Vue.use(VueRouter)
// Vue.use(VModal, { dialog: true })

const routes = [
  {
    path: '/',
    name: 'member_login',
    meta: 'user_view',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/examinations',
    name: 'member_index',
    meta: 'user_view',
    component: () => import('../views/examinations/Index.vue')
  },
  {
    path: '/examinations/:id/report',
    name: 'member_view',
    meta: 'user_view',
    component: () => import('../views/examinations/Report.vue')
  },
  {
    path: '/measurement',
    name: 'member_measure',
    meta: 'user_view',
    component: () => import('../views/Measurement.vue')
  },
  {
    path: '/terms',
    name: 'member_terms',
    meta: 'user_view',
    component: () => import('../views/Terms.vue')
  }
]

// const router = new VueRouter({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes
// })

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
